module.exports = __webpack_public_path__ + "static/media/cat.f94b55e6.png";